import request from '@/utils/request'

// 获取价格档位列表
export function createOrder(data) {
  return request({
    url: '/ai/order/createOrder',
    method: 'post',
    data
  })
}


// 获取订单信息
export function getOrderInfo(params) {
  return request({
    url: '/order/getOrderInfo',
    method: 'get',
    params
  })
}


